import React, { FC } from 'react'
import cx from 'classnames'

import * as SC from './styled'

export type FooterDisclaimerProps = {
  className?: string
  title: string
  text: string
}

const FooterDisclaimer: FC<FooterDisclaimerProps> = (props) => {
  const { className, title, text } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.Column>
        <SC.Title>{title}</SC.Title>
        <SC.Markdown text={text} />
      </SC.Column>
    </SC.Container>
  )
}

export default FooterDisclaimer
